<template>
  <div class="toggle-mode-dark d-md-flex d-none" @click="toggleTheme">
    <a class="">
      <i
        :class="theme === 'dark' ? 'ti ti-toggle-left' : 'ti ti-toggle-right'"
      ></i>
      <span>{{ theme === "dark" ? "Lights on" : "Lights off" }}</span>
    </a>
  </div>
</template>


<script>
import { EventBus } from "@/EventBus";
export default {
  data() {
    return {
      theme: localStorage.getItem("theme") || "light",
    };
  },
  mounted() {
    this.setTheme();
    EventBus.$on("triggerToggleTheme", this.toggleTheme);
  },
  methods: {
    toggleTheme() {
      this.theme = this.theme === "light" ? "dark" : "light";
      this.setTheme();
      EventBus.$emit("themeChanged", this.theme);
    },
    setTheme() {
      document.body.setAttribute("data-bs-theme", this.theme);
      localStorage.setItem("theme", this.theme);
    },
  },
};
</script>